// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overChartText[data-v-6764ce0f] {\n  position: absolute;\n  top: 50px;\n  left: 50px;\n  font-size: 36px;\n  color: #343946;\n}", ""]);
// Exports
module.exports = exports;
